import { render, staticRenderFns } from "./NotAllowedListComponent.vue?vue&type=template&id=348ae4be&scoped=true&"
import script from "./NotAllowedListComponent.vue?vue&type=script&lang=js&"
export * from "./NotAllowedListComponent.vue?vue&type=script&lang=js&"
import style0 from "./NotAllowedListComponent.vue?vue&type=style&index=0&id=348ae4be&lang=scss&scoped=true&"
import style1 from "./NotAllowedListComponent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348ae4be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VContainer,VFlex,VLayout})
